import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MessageService } from 'src/app/service/common/message.service';
import { InvoiceService } from 'src/app/service/pages/invoice.service';

@Component({
  selector: 'app-invoice-modal',
  templateUrl: './invoice-modal.component.html',
  styleUrls: ['./invoice-modal.component.css']
})
export class InvoiceModalComponent implements OnInit {

  private _subs: Subscription = new Subscription();

  constructor(
    private msgService : MessageService,
    private invoiceService : InvoiceService,
    @Inject(MAT_DIALOG_DATA) public data : any,
    private dialogRef : MatDialogRef<InvoiceModalComponent>,
    private datepipe : DatePipe
  ) { 
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
  }

  saveInvoice(invoice){
    invoice.invoiceDate = this.datepipe.transform(invoice.invoiceDate, 'yyyy-MM-dd');
    invoice.caseId = this.data.caseId;
    this._subs.add(
      this.invoiceService.saveInvoice(invoice).subscribe(res=>{
        console.log(res);
        if(res.status == 'ok'){
          this.dialogRef.close(true);
          this.msgService.success(res.message);
        }else{
          this.msgService.error(res.message);
        }
      })
    )
  }

  closeModal(){
    this.dialogRef.close(null);
  }

  ngOnDestroy(){
    this._subs.unsubscribe();
  }

}
